import apiFetch from '../apiFetch'

export default function (token, campaigns, dossierid) {
  return apiFetch({ endPoint: `campaign/configureCampaign?dossierid=${dossierid}`, method: 'PUT', token: token, body: campaigns })
}
